import { api } from './api';
import { createRequestQueue } from '../utils/requestQueue';

const historyQueue = createRequestQueue(2);
const fail = () => { throw new Error('INVALID_ORGANIZATION_OVERVIEW'); };
const count = (value) => Number.isSafeInteger(value) && value >= 0 ? value : fail();
export const requireOverviewAccess = (actor) => {
    if (!actor?.user?.uuid || !['ACCOUNT_ADMIN', 'CLINIC_ADMIN'].includes(actor.role?.name)
        || actor.role.disabled || !actor.role.uuid || !actor.role.account?.uuid) throw new Error('OVERVIEW_ACCESS_DENIED');
    return { 'CHEART-ROLE': actor.role.uuid };
};
const ownRow = (rows, uuid) => {
    if (!Array.isArray(rows) || rows.length !== 1 || rows[0]?.clinic?.uuid !== uuid) fail();
    return rows[0];
};
export const getOrganizationOverview = async (actor, { at = new Date().toISOString(), signal } = {}) => {
    const headers = requireOverviewAccess(actor);
    if (typeof at !== 'string' || !Number.isFinite(Date.parse(at))) throw new Error('INVALID_OVERVIEW_DATE');
    Object.assign(headers, { 'CHEART-QUERY-TIMESTAMP-START': at, 'CHEART-QUERY-TIMESTAMP-END': at });
    const { data } = await api.get('/cheart/admin/overview', { headers, signal });
    const users = ownRow(data?.users, actor.role.account.uuid);
    const plans = ownRow(data?.plans, actor.role.account.uuid);
    return {
        at, doctors: count(users.total?.DOCTOR), healthcare_staff: count(users.total?.CLINIC_CARE_GIVER),
        patients: count(users.total?.PATIENT), ongoing_patient_plans: count(plans.active),
        managers: count(users.total?.ACCOUNT_ADMIN), administratives: count(users.total?.CLINIC_ADMIN)
    };
};
export const overviewMonths = (now = new Date()) => Array.from({ length: 6 }, (_, i) =>
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 6 + i, 1)).toISOString().slice(0, 10));
export const getOrganizationHistoryPoint = async (actor, { month, kind, signal }) => {
    const headers = requireOverviewAccess(actor);
    if (!/^\d{4}-\d{2}-01$/.test(month) || !['patients', 'plans'].includes(kind)) throw new Error('INVALID_OVERVIEW_PERIOD');
    const first = new Date(month + 'T00:00:00Z');
    if (!Number.isFinite(first.getTime()) || first.toISOString().slice(0, 10) !== month) throw new Error('INVALID_OVERVIEW_PERIOD');
    const end = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 1) - 1).toISOString();
    headers['CHEART-QUERY-TIMESTAMP-END'] = end;
    // Without START the backend counts registrations from its inception date.
    if (kind === 'plans') headers['CHEART-QUERY-TIMESTAMP-START'] = end;
    const { data } = await historyQueue(() => api.get('/cheart/admin/overview', { headers, signal }), signal);
    const row = ownRow(kind === 'patients' ? data?.users : data?.plans, actor.role.account.uuid);
    return kind === 'patients' ? { month, patients: count(row.new?.PATIENT) }
        : { month, ongoing_patient_plans: count(row.active) };
};
export const overviewErrorMessage = (error) => error?.response?.status === 403
    ? 'O acesso às estatísticas ainda não está disponível para este perfil.'
    : error?.response?.status === 401 ? 'A sessão expirou. Volte a iniciar sessão.'
        : 'Não foi possível carregar as estatísticas. Tente novamente.';
export const retryOverview = (failures, error) =>
    ![401, 403].includes(error?.response?.status) && error?.name !== 'CanceledError' && failures < 1;
